import React from "react";
import { Link } from "react-router-dom";
import styles from "./ButtonPage.module.css"; // Import the new CSS module

const ButtonPage = () => {
  return (
    <div className={styles.actionPromptContainer}>
      <Link to="https://cal.com/gfa-admin-fczjtr/30min" className={styles.callToActionLink}>
        <button className={styles.animatedCallToAction}>
          Book Your Free Call Now
        </button>
      </Link>
    </div>
  );
};

export default ButtonPage;